import React from "react";
import PropTypes from "prop-types";
import { connect } from "formik";
import Input from "venuescanner-js/react/components/SelectField/LocationField";
import formikShape from "../../shapes/formik.js";
import InvalidMessage from "venuescanner-js/react/components/Form/Notifications/InvalidMessage";
import classes from "./Input.module.scss";
import cl from "classnames";

const InputForm = ({
  id,
  name = "text",
  value = "",
  locationKey = "slug",
  inputStyles = false,
  formik,
  label,
  ...props
}) => {
  return (
    <div
      className={cl([
        classes.input,
        { "form-error": formik.touched[name] && formik.errors[name] },
      ])}
    >
      {label && <label>{label}</label>}
      <Input
        id={id}
        name={name}
        // errors={formik.errors}
        fullLocation={true}
        isForm={true}
        label={label}
        inputStyles={inputStyles}
        // value={formik.values[name]}
        onChange={(location) => {
          // console.log({ location })
          const val = location
            ? locationKey
              ? location[locationKey]
              : location
            : null;
          // console.log(formik.values[name], val)
          formik.setFieldTouched(name, true);
          if (
            !formik.values[name] ||
            !val ||
            formik.values[name].id !== val.id
          ) {
            formik.setFieldValue(name, val);
          }
        }}
        {...props}
      />
      <InvalidMessage error={formik.touched[name] && formik.errors[name]} />
    </div>
  );
};

InputForm.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.string,
  label: PropTypes.string,
  locationKey: PropTypes.string,
  formik: formikShape,
};
export default connect(({ formik, ...props }) => {
  return <InputForm formik={formik} {...props} />;
});
